import _ from 'lodash';

export const getConsentTypesForAccount = (account, formData) => {
  const industryConsentTypes = _.get(account, 'industries', [])
    .map(industry =>
      _.find(_.get(formData, 'industries', []), { id: industry })
    )
    .reduce(
      (types, industry) => types.concat(_.get(industry, 'consentTypes', [])),
      []
    );

  const consentTypes = _.uniqBy(
    _.get(account, 'consents', []).concat(industryConsentTypes),
    'id'
  );

  return consentTypes;
};
